import { UserState } from "../Model/UserState";
import { UserRepository } from "../Repository/UserRepository";


export interface UpdateStateUserUseCase {
    invoke: (data: UserState) => Promise<boolean>;
  }
  
  export class UpdateStateUser implements UpdateStateUserUseCase {
    private userRepo: UserRepository;
    constructor(_UserRepo: UserRepository) {
      this.userRepo = _UserRepo;
    }
  
    async invoke(data: UserState){
       
        if(!data){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.userRepo.updateStateUser(data);
        return update;
    }
  }